import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import getLocalToken from '../getLocalToken';

const PreventedRoute = ({ path, component: Component }) => {
  const token = getLocalToken();

  return (
    <Route path={path}>{token ? <Redirect to="/" /> : <Component />}</Route>
  );
};

PreventedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.node.isRequired,
};

export default PreventedRoute;
